<template>
  <ol class="weighing-steps">
    <li class="weighing-steps__step">{{ texts.STEP_TARE }}</li>
    <li class="weighing-steps__step">{{ weighingStep }}</li>
    <li class="weighing-steps__step">{{ texts.STEP_WRITE }}</li>
  </ol>
</template>

<script>
import { TEXTS } from '../cookedWeightsConstants'
import { describeWeighingStep } from '../groupComposition'

export default {
  name: 'WeighingSteps',
  props: {
    ingredients: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    texts () {
      return TEXTS
    },
    weighingStep () {
      return describeWeighingStep(this.ingredients)
    }
  }
}
</script>

<style scoped>
.weighing-steps {
  margin: 0 0 12px;
  padding: 0;
  list-style: none;
  counter-reset: weighing-step;
}

.weighing-steps__step {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 4px 0;
  font-size: var(--font-base);
  color: var(--text-strong);
  counter-increment: weighing-step;
}

.weighing-steps__step::before {
  content: counter(weighing-step);
  flex: 0 0 auto;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  font-size: var(--font-small);
  font-weight: 700;
  line-height: 26px;
  text-align: center;
  color: var(--text-inverse);
  background-color: var(--brand-green);
}
</style>
